export default function currencyFormatter(value) {
  const currencyValue = parseInt(value, 10);
  if (Number.isNaN(currencyValue)) {
    return '';
  }

  const result = currencyValue
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

  return `$${result}`;
}
